<script>import Button from "../../components/Button.svelte";
import { theme } from "../../stores/theme.js";
export let caption = void 0;
export let noprint = false;
export let onProperties = void 0;
</script>

<tr class="section {noprint ? 'noprint' : ''}"
  ><td>
    {#if caption && caption.length > 0}
      <h2>{caption}</h2>
    {/if}
    <div class="time-plot">
      {#if onProperties}
        <div class="noprint float">
          <Button
            story={$theme === "dark"
              ? "button.secondary.medium.icon"
              : "button.primary.medium.icon"}
            on:click={onProperties}><span class="glyph-cog" /></Button
          >
        </div>
      {/if}

      <div class={noprint ? "not-included" : ""}>
        <slot></slot>
        <div></div>
      </div>
    </div>
  </td></tr
>

<style>
  tr.section td {
    color: var(--section-onSurface-color);
  }
  @media screen {
    .float {
    float: inline-end;
    position: relative;
    z-index: 10000;
  }

    tr.section td div.time-plot {
      text-align: center;
    }
    .not-included {
      -webkit-filter: blur(5px) grayscale(1);
      -moz-filter: blur(5px) grayscale(1);
      -o-filter: blur(5px) grayscale(1);
      -ms-filter: blur(5px) grayscale(1);
      filter: blur(5px) grayscale(1);
    }
  }
  @media print {
    .not-included,
    .noprint {
      display: none;
      position: absolute;
      border: none;
      left: -9999px;
    }
  }
</style>
